import { createSlice } from "@reduxjs/toolkit";

export const IMAGE_EDITOR_MODES = {
  paint: "paint",
  rect: "rect",
  erase: "erase",
}

const initialState = {
  processing: false,
  brushSize: 30,
  scale: 1,
  mode: IMAGE_EDITOR_MODES.paint,
  ratio: "1024x1024",
  image: null,
  mask: null,
  prompt: "",
}

const imageEditor = createSlice({
  name: "imageEditor",
  initialState: initialState,
  reducers: {
    reset() {
      return initialState;
    },
    setMask(state, action) {
      state.mask = action.payload;
    },
    setImage(state, action) {
      state.image = action.payload;
    },
    setRatio(state, action) {
      state.ratio = action.payload;
    },
    setProcessing(state, action) {
      state.processing = action.payload;
    },
    setMode(state, action) {
      state.mode = action.payload;
    },
    setBrushSize(state, action) {
      state.brushSize = action.payload;
    },
    setPrompt(state, action) {
      state.prompt = action.payload;
    }
  }
});

export const imageEditorActions = imageEditor.actions;

export default imageEditor.reducer;